import React, { Component } from 'react';
import CreatableSelect from 'react-select/creatable';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import Spin from '../../../components/loading';
import Select from 'react-select';
import './styles.scss';
import * as contractActions from '../../../redux/contract/actions';
import * as introducedCafesActions from '../../../redux/introducedCafes/actions';
import {
  validator,
  formatter,
  domManipulator,
  toastMessage,
} from '../../../utils';
import ENUMS from '../../../enums';
import FailedMessagesList from '../../../components/failedMesasgesList';
import AddOrEditCafeContractContext from './AddOrEditCafeContractContext';
import ImageUploader from '../../../components/imageUploader';
import DatePicker from './../../../components/FormElements/DatePicker/DatePicker';
import { getAllCafeNamesForPanel } from '../../../redux/cafes/actions';

class AddOrEditCafeContract extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      cafeName: '',
      nameInputValidateStatus: '',
      nameInputInvalidMessage: '',
      bankName: '',
      bankNameInputValidateStatus: '',
      bankNameInputInvalidMessage: '',
      cardNumber: '',
      cardNumberInputValidateStatus: '',
      cardNumberInputInvalidMessage: '',
      accountNumber: '',
      accountNumberInputValidateStatus: '',
      accountNumberInputInvalidMessage: '',
      cafeManagerName: '',
      cafeManagerNameInputValidateStatus: '',
      cafeManagerNameInputInvalidMessage: '',
      date: '',
      dateValidateStatus: '',
      dateInvalidMessage: '',
      fromDate: '',
      fromDateValidateStatus: '',
      fromDateInvalidMessage: '',
      toDate: '',
      toDateValidateStatus: '',
      toDateInvalidMessage: '',
      cityCode: '',
      citiesInputInvalidMessage: '',
      citiesInputValidateStatus: '',
      licenseFileName: '',
      licenseUrl: '',
      contractFileName: '',
      contractUrl: '',
      cafeLogo: null,
      loaded: false,
      rseeStockType: 'RSEE_PERCENT',
      changeRseeStockTypeWarningText: '',
      cafeType: 'NORMAL',
      changeCafeTypeWarningText: '',
      introducedCafeId: '',
    };
  }

  getDateReference = React.createRef();
  getFromDateReference = React.createRef();
  getToDateReference = React.createRef();

  componentWillMount() {
    window.scrollTo(0, 0);

    this.props.actions.clearForm();

    if (
      this.props.location.pathname === '/cafes-contract/edit' &&
      !(
        this.props.editMode &&
        this.props.location &&
        this.props.location.contractId
      )
    ) {
      return this.props.history.push('/cafes-contract');
    } else if (this.props.location.pathname === '/cafes-contract/edit') {
      this.props.actions.getContractById(this.props.location.contractId);
    }

    this.props.actions.getCitiesContract();

    if (this.props.location?.cafeCityCode) {
      this.setState({
        cityCode: this.props.location.cafeCityCode,
        introducedCafeId: this.props.location.id,
      });
      this.props.actions.getCityContract(this.props.location.cafeCityCode);
    }
    console.log(this.props.location.id);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.cityData !== this.props.cityData && this.props.cityData) {
      this.onChangeToDate(this.props.cityData.contractToDate);
      this.onChangeFromDate(this.props.cityData.contractFromDate);
    }

    if (
      this.props.editMode &&
      prevState.loaded === false &&
      !!this.props.fetchedCafeContractById
    ) {
      const {
        id,
        cafeName,
        bankName,
        cardNumber,
        accountNumber,
        cafeManagerName,
        date,
        startDate,
        endDate,
        cityCode,
        licenseUrl,
        contractUrl,
        licenseFileName,
        contractFileName,
        rseeStockType,
        cafeType,
      } = this.props.fetchedCafeContractById;

      this.setState(() => ({
        loaded: true,
        id,
        cafeName,
        bankName,
        cardNumber,
        accountNumber,
        cafeManagerName,
        date,
        fromDate: startDate,
        toDate: endDate,
        cityCode,
        licenseUrl,
        contractUrl,
        licenseFileName,
        contractFileName,
        rseeStockType,
        cafeType,
      }));
    }
  }

  onNameChange = e => {
    let cafeName;
    if (this.state.id) {
      cafeName = e.target.value;
    } else {
      cafeName = e;
    }
    if (!cafeName || validator.hasMaxLength(cafeName, { maxLength: 50 })) {
      this.setState(() => ({
        cafeName,
        nameInputInvalidMessage: '',
        nameInputValidateStatus: '',
      }));
    }
  };

  onBankNameChange = e => {
    const bankName = e.target.value;

    if (!bankName || validator.hasMaxLength(bankName, { maxLength: 64 })) {
      this.setState(() => ({
        bankName,
        bankNameInputInvalidMessage: '',
        bankNameInputValidateStatus: '',
      }));
    }
  };

  onCardNumberChange = e => {
    const cardNumber = e.target.value;

    if (!cardNumber || validator.hasMaxLength(cardNumber, { maxLength: 16 })) {
      this.setState(() => ({
        cardNumber,
        cardNumberInputInvalidMessage: '',
        cardNumberInputValidateStatus: '',
      }));
    }
  };

  onAccountNumberChange = e => {
    const accountNumber = e.target.value;

    if (
      !accountNumber ||
      validator.hasMaxLength(accountNumber, { maxLength: 64 })
    ) {
      this.setState(() => ({
        accountNumber,
        accountNumberInputInvalidMessage: '',
        accountNumberInputValidateStatus: '',
      }));
    }
  };

  onCafeManagerNameChange = e => {
    const cafeManagerName = e.target.value;

    if (
      !cafeManagerName ||
      validator.hasMaxLength(cafeManagerName, { maxLength: 64 })
    ) {
      this.setState(() => ({
        cafeManagerName,
        cafeManagerNameInputInvalidMessage: '',
        cafeManagerNameInputValidateStatus: '',
      }));
    }
  };

  onChangeCafeType = event => {
    let type = event.target.value;
    this.setState(() => ({
      bankNameInputValidateStatus: '',
      bankNameInputInvalidMessage: '',
      cardNumberInputValidateStatus: '',
      cardNumberInputInvalidMessage: '',
      accountNumberInputValidateStatus: '',
      accountNumberInputInvalidMessage: '',
      cafeType: type,
    }));
  };

  onChangeDate = val => {
    this.setState({
      date: val,
      dateValidateStatus: '',
      dateInvalidMessage: '',
    });
  };

  onChangeFromDate = val => {
    this.setState({
      fromDate: val,
      fromDateValidateStatus: '',
      fromDateInvalidMessage: '',
    });
  };

  onChangeToDate = val => {
    this.setState({
      toDate: val,
      toDateValidateStatus: '',
      toDateInvalidMessage: '',
    });
  };

  onChangeRseeStockType = event => {
    const type = event.target.value;
    this.setState({
      rseeStockType: type,
    });

    if (this.props.editMode === true) {
      if (
        type === 'RSEE_PERCENT' &&
        type !== this.props.fetchedCafeContractById.rseeStockType
      ) {
        this.setState({
          changeRseeStockTypeWarningText: locales(
            'warning.you.changed.the.rsee.stock.type.please.enter.rsee.percent.too',
          ),
        });
      } else if (
        type === 'RSEE_AMOUNT' &&
        type !== this.props.fetchedCafeContractById.rseeStockType
      ) {
        this.setState({
          changeRseeStockTypeWarningText: locales(
            'warning.you.changed.the.rsee.stock.type.please.enter.rsee.amount.too',
          ),
        });
      }
    } else {
      this.setState({ changeRseeStockTypeWarningText: '' });
    }
  };

  validateForm = () => {
    return new Promise((resolve, reject) => {
      const standardName = formatter.toStandard(this.state.cafeName);
      const standardBankName = formatter.toStandard(this.state.bankName);
      const standardCardNumber = formatter.toStandard(this.state.cardNumber);
      const standardAccountNumber = formatter.toStandard(
        this.state.accountNumber,
      );

      const standardCafeManagerName = formatter.toStandard(
        this.state.cafeManagerName,
      );
      const standardCity = formatter.toStandard(this.state.cityCode);

      let isNameValid;
      let isBankNameValid;
      let isCardNumberValid;
      let isAccountNumberValid;
      let isCafeManagerNameValid;
      let isDate;
      let isFromDate;
      let isToDate;
      let isCitiesValid;
      let firstErrorElementId = '';
      let errors = {};

      if (!standardName) {
        errors.nameInputInvalidMessage = locales(
          'messages.fieldValueIsRequired',
          {
            fieldName: locales('fields.cafe.name'),
          },
        );
        errors.nameInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'cafeName';
        isNameValid = false;
      } else {
        errors.nameInputInvalidMessage = '';
        errors.nameInputValidateStatus = '';
        isNameValid = true;
      }

      if (this.state.cafeType === 'NORMAL' && !standardBankName) {
        errors.bankNameInputInvalidMessage = locales(
          'messages.fieldValueIsRequired',
          {
            fieldName: locales('fields.bank.name'),
          },
        );
        errors.bankNameInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'bankName';
        isBankNameValid = false;
      } else {
        errors.bankNameInputInvalidMessage = '';
        errors.bankNameInputValidateStatus = '';
        isBankNameValid = true;
      }

      if (this.state.cafeType === 'NORMAL' && !standardCardNumber) {
        errors.cardNumberInputInvalidMessage = locales(
          'messages.fieldValueIsRequired',
          {
            fieldName: locales('fields.card.number'),
          },
        );
        errors.cardNumberInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'cardNumber';
        isCardNumberValid = false;
      } else {
        errors.cardNumberInputInvalidMessage = '';
        errors.cardNumberInputValidateStatus = '';
        isCardNumberValid = true;
      }

      if (this.state.cafeType === 'NORMAL' && !standardAccountNumber) {
        errors.accountNumberInputInvalidMessage = locales(
          'messages.fieldValueIsRequired',
          {
            fieldName: locales('fields.account.number'),
          },
        );
        errors.accountNumberInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'accountNumber';
        isAccountNumberValid = false;
      } else {
        errors.accountNumberInputInvalidMessage = '';
        errors.accountNumberInputValidateStatus = '';
        isAccountNumberValid = true;
      }

      if (!standardCafeManagerName) {
        errors.cafeManagerNameInputInvalidMessage = locales(
          'messages.fieldValueIsRequired',
          {
            fieldName: locales('fields.cafe.owner.full.name'),
          },
        );
        errors.cafeManagerNameInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'cafeManagerName';
        isCafeManagerNameValid = false;
      } else {
        errors.cafeManagerNameInputInvalidMessage = '';
        errors.cafeManagerNameInputValidateStatus = '';
        isCafeManagerNameValid = true;
      }

      if (!this.state.date.length) {
        isDate = false;
        firstErrorElementId = firstErrorElementId || 'date';
        errors.dateInvalidMessage = locales('messages.fieldValueIsRequired', {
          fieldName: locales('fields.cafe.contract.date'),
        });
        errors.dateValidateStatus = 'is-invalid-feedback';
      } else {
        isDate = true;
        errors.dateInvalidMessage = '';
        errors.dateValidateStatus = '';
      }

      if (!this.state.fromDate.length) {
        isFromDate = false;
        firstErrorElementId = firstErrorElementId || 'fromDate';
        errors.fromDateInvalidMessage = locales(
          'messages.fieldValueIsRequired',
          {
            fieldName: locales('fields.cafe.contract.start.date'),
          },
        );
        errors.fromDateValidateStatus = 'is-invalid-feedback';
      } else {
        isFromDate = true;
        errors.fromDateInvalidMessage = '';
        errors.fromDateValidateStatus = '';
      }

      if (!this.state.toDate.length) {
        isToDate = false;
        firstErrorElementId = firstErrorElementId || 'toDate';
        errors.toDateInvalidMessage = locales('messages.fieldValueIsRequired', {
          fieldName: locales('fields.cafe.contract.end.date'),
        });
        errors.toDateValidateStatus = 'is-invalid-feedback';
      } else {
        isToDate = true;
        errors.toDateInvalidMessage = '';
        errors.toDateValidateStatus = '';
      }

      if (!standardCity) {
        isCitiesValid = false;
        firstErrorElementId = 'cityCode';
        errors.citiesInputInvalidMessage = locales(
          'messages.selectCitiesIsMandatory',
        );
        errors.citiesInputValidateStatus = 'is-invalid';
      } else {
        isCitiesValid = true;
        errors.citiesInputInvalidMessage = '';
        errors.citiesInputValidateStatus = '';
      }

      const isFormValid =
        isNameValid &&
        isBankNameValid &&
        isCardNumberValid &&
        isAccountNumberValid &&
        isCafeManagerNameValid &&
        isDate &&
        isFromDate &&
        isToDate &&
        isCitiesValid;

      if (!isFormValid) {
        console.log('errors', errors);
        console.log('firstErrorElementId', firstErrorElementId);
        this.setState(
          () => ({
            ...errors,
          }),
          () => {
            domManipulator.scrollIntoView(firstErrorElementId);
            resolve(false);
          },
        );
      } else {
        resolve(true);
      }
    });
  };

  saveForm = async event => {
    event.preventDefault();

    const isFormValid = await this.validateForm();
    if (!isFormValid) {
      console.log('form is not valid');
      return;
    }

    domManipulator.scrollToTop();
    let standardName;
    if (this.state.id) {
      standardName = formatter.toStandard(this.state.cafeName);
    } else {
      let name = this.state.cafeName.value;
      standardName = formatter.toStandard(name);
    }
    const standardBankName = formatter.toStandard(this.state.bankName);
    const standardCardNumber = formatter.toStandard(this.state.cardNumber);
    const standardAccountNumber = formatter.toStandard(
      this.state.accountNumber,
    );

    const standardCafeManagerName = formatter.toStandard(
      this.state.cafeManagerName,
    );
    const standardCity = formatter.toStandard(this.state.cityCode);

    let {
      licenseUrl,
      contractUrl,
      licenseFileName,
      contractFileName,
    } = this.state;

    let contractObject = {
      cafeName: standardName,
      bankName: standardBankName,
      cardNumber: standardCardNumber,
      accountNumber: standardAccountNumber,
      cafeManagerName: standardCafeManagerName,
      cafeType: this.state.cafeType,
      cityCode: standardCity,
      licenseFileName,
      contractFileName,
      date: this.getDateReference.current.value,
      startDate: this.getFromDateReference.current.value,
      endDate: this.getToDateReference.current.value,
      rseeStockType: this.state.rseeStockType,
      introducedCafeId: this.state.introducedCafeId,
    };

    if (this.props.editMode === true) {
      contractObject = {
        ...contractObject,
        licenseUrl,
        contractUrl,
        id: this.props.location.contractId,
      };

      this.props.actions
        .updateCafeContract(contractObject)
        .then(() => {
          this.props.history.push('/cafes-contract');
          toastMessage.show({
            text: locales('titles.editionsDoneSuccessfully'),
            icon: 'success',
          });
        })
        .catch(err => console.error(err));
    } else {
      this.props.actions
        .insertCafeContract(contractObject)
        .then(() => {
          if (this.props.location.introducedCafe) {
            let data = {
              id: this.props.location.id,
              status: this.props.location.status,
            };
            this.props.actions
              .changeCafeStatus(data.status, '', data.id)
              .then(() => {
                this.props.history.push('/introduced-cafes');
                toastMessage.show({
                  text: locales('titles.insertedSuccessfully'),
                  icon: 'success',
                });
              });
          } else {
            this.props.history.push('/cafes-contract');
            toastMessage.show({
              text: locales('titles.insertedSuccessfully'),
              icon: 'success',
            });
          }
        })
        .catch(err => console.error(err));
    }
  };

  onUploadLicenseSuccess = uploadedFile => {
    this.setState(() => ({
      licenseFileName: uploadedFile.fileName,
      licenseUrl: uploadedFile.url,
    }));
  };

  onUploadCafeContractImagesSuccess = uploadedCafeContractImages => {
    this.setState(() => ({
      contractFileName: uploadedCafeContractImages.fileName,
      contractUrl: uploadedCafeContractImages.url,
    }));
  };

  deleteCafeImage = _ => {
    this.setState(() => ({
      contractFileName: null,
      contractUrl: null,
    }));
  };

  deleteLicenseUrl = _ => {
    this.setState(() => ({
      licenseUrl: null,
      licenseFileName: null,
    }));
  };

  onSelectCities = cityCode => {
    this.setState(() => ({
      cityCode: cityCode.value.toLowerCase(),
      citiesInputInvalidMessage: '',
      citiesInputValidateStatus: '',
    }));

    this.props.actions.getAllCafeNamesForPanel(cityCode.value.toLowerCase());
  };

  cancelForm = () => {
    if (this.props.location.introducedCafe) {
      return this.props.history.push('/introduced-cafes');
    } else {
      return this.props.history.push('/cafes-contract');
    }
  };

  render() {
    return (
      <AddOrEditCafeContractContext.Provider
        value={{
          addContactItem: this.addContactItem,
          editContactItem: this.editContactItem,
          addWorkingHourItem: this.addWorkingHourItem,
          editWorkingHourItem: this.editWorkingHourItem,
        }}
      >
        <Spin
          spinning={
            this.props.addOrEditCafeContractLoading ||
            this.props.getCitiesContractLoading ||
            this.props.getCafeContractByIdLoading
          }
          className='col-9 mt-5'
        >
          <section className='page-header'>
            <h1>{locales('titles.contract')}</h1>
            <div className='form-actions'>
              <button
                type='submit'
                className='btn btn-success w-100'
                onClick={this.saveForm}
              >
                <i className='fa fa-save' />
                {locales('labels.save')}
              </button>
              <button
                className='btn btn-default w-100'
                onClick={this.cancelForm}
                type='button'
              >
                {locales('labels.cancel')}
              </button>
            </div>
          </section>

          <section className='panel panel-default'>
            <div className='panel-heading'>
              <h3 className='panel-title'>
                <i className='fa fa-pencil'></i>
                {this.props.editMode
                  ? locales('titles.edit.cafe')
                  : locales('titles.submit.new.contract')}
              </h3>
            </div>
            <div className='panel-body'>
              <form ref='form' className='col form-horizontal'>
                <FailedMessagesList
                  className='errors-list'
                  messagesList={
                    this.props.addOrEditCafeContractFailedMessagesList
                  }
                />
                {this.props.addOrEditCafeError && (
                  <div
                    className={`errors-list ${this.props.className} alert alert-danger alert-dismissible fade show`}
                    role='alert'
                  >
                    {locales('messages.server.error')}
                  </div>
                )}
                <section>
                  <div id='geo-location-contracts'>
                    <h6 className='contract-line-container text-primary'>
                      <span className='line'>
                        <i className='fal fa-map-marker-alt px-1' />
                        {locales('titles.geo.location')}
                        <i className='fal fa-map-marker-alt px-1' />
                      </span>
                    </h6>
                    <div className='form-row'>
                      <div className='form-group col d-flex justify-content-end required'>
                        <label
                          className='rsee-form-label col-2 text-right'
                          htmlFor='cities'
                        >
                          {locales('messages.selectCities')}
                        </label>
                        <div className='full-width'>
                          <Select
                            placeholder={
                              this.state.cityCode
                                ? this.props.cities &&
                                  this.props.cities.length &&
                                  this.props.cities.find(
                                    item =>
                                      // item.key ===
                                      item.cityCode ===
                                      this.state.cityCode.toUpperCase(),
                                  ).name
                                : locales('messages.select.cities')
                            }
                            isMulti={false}
                            id='cities'
                            name='cities'
                            options={this.props.cities?.map(x => ({
                              value: x.cityCode,
                              label: x.name,
                            }))}
                            className={`rc-dropdown ${this.state.citiesInputValidateStatus}`}
                            onChange={selected => this.onSelectCities(selected)}
                            isDisabled={
                              this.props.editMode ||
                              this.props.cityData?.hasRegistrationFee
                            }
                          />
                          <div className='invalid-feedback'>
                            {this.state.citiesInputInvalidMessage}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div id='cafe-info-contracts'>
                    <h6 className='contract-line-container text-primary'>
                      <span className='line'>
                        <i className='fal fa-coffee px-1' />
                        {locales('titles.cafe.info')}
                        <i className='fal fa-coffee px-1' />
                      </span>
                    </h6>
                    <div className='form-row'>
                      <div className='form-group col-6 d-flex required'>
                        <label
                          className='rsee-form-label col-3 text-right'
                          htmlFor='cafeName'
                        >
                          {locales('fields.cafe.name')}
                        </label>

                        <div className={`full-width`}>
                          {this.state.id ? (
                            <input
                              id='cafeName'
                              name='cafeNameTextInput'
                              type='text'
                              className={`form-control ${this.state.nameInputValidateStatus}`}
                              onChange={this.onNameChange}
                              autoComplete='off'
                              value={this.state.cafeName}
                              maxLength='50'
                            />
                          ) : (
                            <CreatableSelect
                              id='cafeName'
                              name='cafeNameSelectInput'
                              isMulti={false}
                              isClearable={true}
                              onChange={this.onNameChange}
                              placeholder={
                                this.state.cafeName
                                  ? this.state.cafeName.name
                                  : locales('messages.sample.cafe.name')
                              }
                              maxLength='50'
                              options={this.props.cafeNamesList.map(item => ({
                                value: item.name,
                                label: item.name,
                              }))}
                              isDisabled={this.state.cityCode === ''}
                            />
                          )}
                          <small className='form-text text-muted'>
                            {locales('maxLength.50')}
                          </small>
                          <div className='invalid-feedback'>
                            {this.state.nameInputInvalidMessage}
                          </div>
                        </div>
                      </div>

                      <div className='form-group col-6 d-flex required'>
                        <label
                          className='rsee-form-label col-3 text-right'
                          htmlFor='cafeManagerName'
                        >
                          {locales('fields.cafe.owner.full.name')}
                        </label>
                        <div className='full-width'>
                          <input
                            id='cafeManagerName'
                            name='cafeManagerName'
                            type='text'
                            className={`form-control ${this.state.cafeManagerNameInputValidateStatus}`}
                            onChange={this.onCafeManagerNameChange}
                            autoComplete='off'
                            value={this.state.cafeManagerName}
                            placeholder={locales(
                              'messages.sample.cafe.owner.full.name',
                            )}
                            maxLength={ENUMS.MAX_LENGTH.fullName}
                          />
                          <small className='form-text text-muted'>
                            {locales('maxLength.50')}
                          </small>
                          <div className='invalid-feedback'>
                            {this.state.cafeManagerNameInputInvalidMessage}
                          </div>
                        </div>
                      </div>
                      <div className='form-group col d-flex required'>
                        <label className='rsee-form-label col-2 text-right'>
                          {locales('cafes.type')}
                        </label>
                        <div className='full-width d-flex justify-content-between'>
                          <div className='d-flex justify-content-start col-4'>
                            {ENUMS.CAFE_TYPE.list.map(type => (
                              <div className='form-check' key={type.value}>
                                <label
                                  className='form-check-label px-1'
                                  htmlFor={'cafeType' + type.value}
                                >
                                  {type.title}
                                </label>
                                <input
                                  className='form-check-input'
                                  type='radio'
                                  name='cafeType'
                                  id={'cafeType' + type.value}
                                  value={type.value}
                                  checked={this.state.cafeType === type.value}
                                  onChange={event =>
                                    this.onChangeCafeType(event)
                                  }
                                />
                              </div>
                            ))}
                          </div>
                          <div className='col-8'>
                            <p className='text-danger'>
                              {this.state.changeCafeTypeWarningText}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div id='contract-info-contracts'>
                    <h6 className='contract-line-container text-primary'>
                      <span className='line'>
                        <i className='fal fa-file-signature px-1' />
                        {locales('titles.contract.info')}
                        <i className='fal fa-file-signature px-1' />
                      </span>
                    </h6>
                    <div className='form-row justify-content-end'>
                      <div className='form-group col-6 d-flex justify-content-between required'>
                        <label className='rsee-form-label col-3 text-right'>
                          {locales('fields.cafe.contract.date')}
                        </label>
                        <div className='full-width'>
                          <DatePicker
                            marge={true}
                            id='date'
                            name='date'
                            elementRef={this.getDateReference}
                            isEditDate={true}
                            className='col-12 p-0 date-picker-input date border rounded py-2'
                            onChange={val => this.onChangeDate(val)}
                            value={this.state.date}
                          />
                          <div
                            className={`invalid-feedback ${this.state.dateValidateStatus}`}
                          >
                            {this.state.dateInvalidMessage}
                          </div>
                        </div>
                      </div>
                      <div className='form-group col-6 d-flex justify-content-between required'>
                        <label className='rsee-form-label col-3 text-right'>
                          {locales('fields.cafe.contract.start.date')}
                        </label>
                        <div className='full-width'>
                          <DatePicker
                            marge={true}
                            name='fromDate'
                            id='fromDate'
                            elementRef={this.getFromDateReference}
                            isEditDate={
                              !this.props.cityData?.hasRegistrationFee
                            }
                            onChange={val => this.onChangeFromDate(val)}
                            value={this.state.fromDate}
                            className={`p-0 date-picker-input start rounded py-2 rc-date-input ${this.state.fromDateValidateStatus}`}
                          />
                          <div
                            className={`invalid-feedback ${this.state.fromDateValidateStatus}`}
                          >
                            {this.state.fromDateInvalidMessage}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='form-row justify-content-end'>
                      <div className='form-group col-6 d-flex required'>
                        <label className='rsee-form-label col-3 text-right'>
                          {locales('fields.cafe.contract.end.date')}
                        </label>
                        <div className='full-width'>
                          <DatePicker
                            marge={true}
                            name='toDate'
                            id='toDate'
                            elementRef={this.getToDateReference}
                            isEditDate={
                              !this.props.cityData?.hasRegistrationFee
                            }
                            onChange={val => this.onChangeToDate(val)}
                            value={this.state.toDate}
                            className={`p-0 date-picker-input start rounded py-2 rc-date-input ${this.state.toDateValidateStatus}`}
                          />
                          <div
                            className={`invalid-feedback ${this.state.toDateValidateStatus}`}
                          >
                            {this.state.toDateInvalidMessage}
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group col-6 d-flex ${this.state
                          .cafeType === 'NORMAL' && 'required'}`}
                      >
                        <label
                          className='rsee-form-label col-3 text-right'
                          htmlFor='bankName'
                        >
                          {locales('fields.bank.name')}
                        </label>
                        <div className='full-width'>
                          <input
                            id='bankName'
                            name='bankName'
                            type='text'
                            className={`form-control ${this.state.bankNameInputValidateStatus}`}
                            onChange={this.onBankNameChange}
                            autoComplete='off'
                            value={this.state.bankName}
                            placeholder={locales('messages.sample.bank.name')}
                            maxLength='50'
                            disabled={this.state.cafeType === 'TAKEAWAY'}
                          />
                          <small className='form-text text-muted'>
                            {locales('maxLength.50')}
                          </small>
                          <div className='invalid-feedback'>
                            {this.state.bankNameInputInvalidMessage}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='form-row justify-content-end'>
                      <div
                        className={`form-group col-6 d-flex ${this.state
                          .cafeType === 'NORMAL' && 'required'}`}
                      >
                        <label
                          className='rsee-form-label col-3 text-right'
                          htmlFor='cardNumber'
                        >
                          {locales('fields.card.number')}
                        </label>
                        <div className='full-width'>
                          <input
                            id='cardNumber'
                            name='cardNumber'
                            type='text'
                            className={`form-control ${this.state.cardNumberInputValidateStatus}`}
                            onChange={this.onCardNumberChange}
                            autoComplete='off'
                            value={this.state.cardNumber}
                            placeholder={locales('messages.sample.card.number')}
                            maxLength='16'
                            disabled={this.state.cafeType === 'TAKEAWAY'}
                          />
                          <small className='form-text text-muted'>
                            {locales('maxLength.16')}
                          </small>
                          <div className='invalid-feedback'>
                            {this.state.cardNumberInputInvalidMessage}
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group col-6 d-flex ${this.state
                          .cafeType === 'NORMAL' && 'required'}`}
                      >
                        <label
                          className='rsee-form-label col-3 text-right'
                          htmlFor='accountNumber'
                        >
                          {locales('fields.account.number')}
                        </label>
                        <div className='full-width'>
                          <input
                            id='accountNumber'
                            name='accountNumber'
                            type='text'
                            className={`form-control ${this.state.accountNumberInputValidateStatus}`}
                            onChange={this.onAccountNumberChange}
                            autoComplete='off'
                            value={this.state.accountNumber}
                            placeholder={locales(
                              'messages.sample.account.number',
                            )}
                            maxLength='50'
                            disabled={this.state.cafeType === 'TAKEAWAY'}
                          />
                          <small className='form-text text-muted'>
                            {locales('maxLength.50')}
                          </small>
                          <div className='invalid-feedback'>
                            {this.state.accountNumberInputInvalidMessage}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div id='rsee-stock-contracts'>
                    <h6 className='contract-line-container text-primary'>
                      <span className='line'>
                        <i className='fal fa-money-check px-1' />
                        {locales('labels.rsee.stock.amount')}
                        <i className='fal fa-money-check px-1' />
                      </span>
                    </h6>
                    <div className='form-row'>
                      <div className='form-group col d-flex required'>
                        <label className='rsee-form-label col-2 text-right'>
                          {locales('labels.rsee.stock.type')}
                        </label>
                        <div className='full-width d-flex justify-content-between'>
                          <div className='d-flex justify-content-start col-4'>
                            {ENUMS.RSEE_STOCK_TYPE.list.map(type => (
                              <div className='form-check' key={type.value}>
                                <label
                                  className='form-check-label px-1'
                                  htmlFor={'rseeStockType' + type.value}
                                >
                                  {type.title}
                                </label>
                                <input
                                  className='form-check-input'
                                  type='radio'
                                  name='rseeStockType'
                                  id={'rseeStockType' + type.value}
                                  value={type.value}
                                  checked={
                                    this.state.rseeStockType === type.value
                                  }
                                  onChange={this.onChangeRseeStockType}
                                  disabled
                                />
                              </div>
                            ))}
                          </div>
                          <div className='col-8'>
                            <p className='text-danger'>
                              {this.state.changeRseeStockTypeWarningText}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div id='cafe-images-contracts'>
                    <h6 className='contract-line-container text-primary'>
                      <span className='line'>
                        <i className='fal fa-image px-1' />
                        {locales('titles.cafe.images')}
                        <i className='fal fa-image px-1' />
                      </span>
                    </h6>
                    <div>
                      <ImageUploader
                        placeholder={locales('fields.cafe.license')}
                        actionUrl={`${API_ENDPOINT}/v1/general/app/upload-cafe-license`}
                        imageFile={this.state.licenseUrl}
                        isMulti={false}
                        onUploadSuccess={this.onUploadLicenseSuccess}
                        deleteImage={this.deleteLicenseUrl}
                        fileName={this.state.licenseFileName}
                      />
                    </div>
                    <ImageUploader
                      placeholder={locales('fields.contract.photos')}
                      actionUrl={`${API_ENDPOINT}/v1/general/app/upload-cafe-contract`}
                      imageFile={this.state.contractUrl}
                      isMulti={false}
                      onUploadSuccess={this.onUploadCafeContractImagesSuccess}
                      deleteImage={this.deleteCafeImage}
                      fileName={this.state.contractFileName}
                    />
                  </div>
                </section>
              </form>
            </div>
          </section>
        </Spin>
      </AddOrEditCafeContractContext.Provider>
    );
  }
}

const mapStateToProps = state => {
  const {
    cities,
    addOrEditCafeContractLoading,
    addOrEditCafeContractFailed,
    addOrEditCafeContractError,
    addOrEditCafeContractFailedMessagesList,

    getCitiesContractLoading,

    getCafeContractByIdLoading,
    getCafeContractByIdFailed,
    getCafeContractByIdError,
    getCafeContractByIdMessage,
    fetchedCafeContractById,

    cityData,
  } = state.cafesContractReducer;

  const { cafeNamesList } = state.cafesReducer;

  return {
    cities,
    addOrEditCafeContractLoading,
    addOrEditCafeContractFailed,
    addOrEditCafeContractError,
    addOrEditCafeContractFailedMessagesList,

    getCitiesContractLoading,

    getCafeContractByIdLoading,
    getCafeContractByIdFailed,
    getCafeContractByIdError,
    getCafeContractByIdMessage,
    fetchedCafeContractById,

    cafeNamesList,

    cityData,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    getCitiesContract: () => dispatch(contractActions.getCitiesContract()),
    insertCafeContract: contractObject =>
      dispatch(contractActions.insertCafeContract(contractObject)),
    updateCafeContract: contractObject =>
      dispatch(contractActions.updateCafeContract(contractObject)),
    getContractById: contractId =>
      dispatch(contractActions.getContractById(contractId)),
    clearForm: () => dispatch(contractActions.clearAddOrEditCafeForm()),
    changeCafeStatus: (status, rejectReason, cafeId) =>
      dispatch(
        introducedCafesActions.changeCafeStatus(status, rejectReason, cafeId),
      ),
    getAllCafeNamesForPanel: cityCode =>
      dispatch(getAllCafeNamesForPanel(cityCode)),
    getCityContract: cityCode =>
      dispatch(contractActions.getCityContract(cityCode)),
  },
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddOrEditCafeContract),
);
